// dependencies
import React, { useRef, useState, useEffect } from 'react'
import { CheckBox } from '@st-operations/uikit/src/v2'

// import toast from '_root/lib/toast.js'
import PropTypes from 'prop-types'

// components
import { Button, BUTTON_THEME, Input } from '@st-operations/uikit/src/v2/index.js'

// lib
import sendAnalytics from '@st-operations/uikit/lib/sendAnalytics.js'

// styles
import './styles.scss'

// component
const NewEntityDialog = ({
  value,
  open,
  title,
  label,
  defaultProperties,
  urlRedirect,
  entities,
  close,
}) => {
  const [inputValue, setInputValue] = useState('')
  const [isGeoAudience, setIsGeoAudience] = useState(false)

  const inputRef = useRef()

  useEffect(() => {
    if (value) {
      setInputValue(value)
    }
  }, [value])

  useEffect(() => {
    if (open) {
      inputRef.current.focus()
    }
  }, [open])

  const onCreate = () => {
    const body = isGeoAudience
      ? { name: inputValue, ...defaultProperties, geo_audience: isGeoAudience }
      : { name: inputValue, ...defaultProperties }
    window._api.post(`/${entities}`, body, (error, item) => {
      if (error) {
        toast.error(error.message)
      } else {
        close()
        if (urlRedirect) {
          window._history.push(`/${urlRedirect}/${item._id}`)
        } else {
          window._history.push(`/${entities}/${item._id}`)
        }
      }

      // event tracking
      sendAnalytics('create', entities, item)
    })
  }

  const onDismiss = () => {
    setIsGeoAudience(false)
    close()
  }

  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      onCreate()
    }
    if (e.key === 'Escape' || (e.metaKey && e.key === 'e')) {
      e.preventDefault()
      onDismiss()
    }
  }

  const updateName = (value) => {
    setInputValue(value)
  }

  const onIsGeoCheckBoxSelect = () => {
    setIsGeoAudience((prevState) => {
      return !prevState
    })
  }

  return (
    <section className="st-new-entity-modal">
      <If condition={title}>
        <h1 className="st-new-entity-modal__title">{title}</h1>
      </If>
      <Input
        ref={inputRef}
        onChange={updateName}
        onKeyDown={onKeyDown}
        value={inputValue}
        label={label}
        classes={{
          root: 'st-new-entity-modal__input',
          input: 'st-new-entity-modal__input-field',
        }}
      />
      <div className="geo-audience-check">
        {' '}
        <CheckBox
          onChange={onIsGeoCheckBoxSelect}
          label="Enable Geographical Search"
          name="geoAudience"
          value={isGeoAudience}
          checked={isGeoAudience}
        />
        <div className="description">
          For privacy concerns, geo-based search groups target audience by zipcodes instead of ID
        </div>
      </div>
      <div className="st-new-entity-modal__buttons">
        <Button
          className="st-new-entity-modal__button"
          theme={BUTTON_THEME.SECONDARY}
          onClick={onDismiss}
        >
          Back
        </Button>
        <Button className="st-new-entity-modal__button" onClick={onCreate}>
          Create
        </Button>
      </div>
    </section>
  )
}

NewEntityDialog.propTypes = {
  title: PropTypes.string,
  label: PropTypes.string,
  open: PropTypes.bool,
  defaultProperties: PropTypes.shape(),
  urlRedirect: PropTypes.string,
  entities: PropTypes.string,
  value: PropTypes.string,
  close: PropTypes.func,
}

NewEntityDialog.defaultProperties = {
  title: '',
  label: 'Name',
  open: false,
  defaultProperties: {},
  urlRedirect: '',
  entities: '',
  value: '',
  close: () => {},
}

// export
export default React.memo(NewEntityDialog)
